<template>
    <div class="activities">
        <div class="title">
            <div></div>
            模板管理
        </div>

        <div class="activities-main">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column align="center" type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column align="center" prop="templateNumber" label="模板ID">
                </el-table-column>
                <el-table-column align="center" prop="templateName" label="模板名称">
                </el-table-column>
                <el-table-column align="center" label="操作" width="240">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 编辑 -->

        <el-dialog title="编辑" :visible.sync="editShow" width="50%" @closed="handleClose">
            <div class="main">
                <el-form ref="forms" :model="form" label-width="80px">
                    <el-form-item label="模板名称" prop="activityName" >
                        <el-input v-model="form.templateName" placeholder="模板名称"></el-input>
                    </el-form-item>
                    <el-form-item label="模板编号" prop="activityName" >
                        <el-input v-model="form.templateNumber" placeholder="模板编号"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editShow = false">取 消</el-button>
                <el-button type="primary" @click="addSubmit('forms')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import { template,editTemplate } from "@/api/api";
export default {
    data() {
        return {
            tableData: [],
            editShow: false,
            form: {
                id:'',
                templateName:'',
                templateNumber:'',
            },

        };
    },
    created() {
        this.getList()
    },
    methods: {
        addSubmit(){
            editTemplate(this.form).then(res=>{
                this.$message({
                    message: '修改成功',
                    type: 'success'
                });
                this.editShow = false
                
                this.getList()
            })
        },
        getList() {
            template().then(res => {
                console.log(res)
                this.tableData = res.data
            })
        },
        //编辑
        edit(row) {
            this.form={...row}
            this.editShow = true
        },
        // 关闭弹窗
        handleClose() {
            this.editShow = false;

        },
    },
};
</script>
  
<style lang="less" scoped>
.activities {
    // height: 100%;
    background: #fff;
    padding: 15px;
    color: #303133;

    .title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;

        div {
            width: 3px;
            height: 16px;
            background: #409eff;
            margin-right: 10px;
        }
    }

    .query {
        margin: 15px 0 30px;
        display: flex;
        align-items: center;

        .query-box {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .el-input {
                width: 260px;
            }

            span {
                width: 60px;
            }
        }
    }

    .activities-main {
        margin: 15px 0;
    }

    .paging {
        display: flex;
        justify-content: flex-end;
    }
}

.active {
    color: #33b959;
}
</style>